import CheckIcon from '@mui/icons-material/Check';
import { Box } from '@mui/material';

import { CHECKBOX_CHECK_ICON_SIZE } from '../constants';
import { buildCheckboxIconContainerSx } from '../utils/general';

import type { CheckboxIconProps } from '../types';

export function CheckboxIcon({ color }: CheckboxIconProps) {
  return <Box component="span" sx={buildCheckboxIconContainerSx(color)} />;
}

export function CheckboxCheckedIcon({ color }: CheckboxIconProps) {
  return (
    <Box component="span" sx={buildCheckboxIconContainerSx(color)}>
      <CheckIcon sx={{ fontSize: CHECKBOX_CHECK_ICON_SIZE, color }} />
    </Box>
  );
}
